import { DynamicPage } from './DynamicPage';

export default DynamicPage;
